import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './App'
import i18n from './i18n/config'
import './styles/index.css'

// Initialize dataLayer as fallback (GTM typically initializes this, but we ensure it exists)
// This ensures dataLayer is available even if GTM hasn't loaded yet
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || []
}

ReactDOM.createRoot(document.getElementById('consultation-wizard-root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
)
